import TRA_NEWF from '../Scripts/Training/MultiTrainingPage/TRA_NEW/TRA_NEW/TRA_NEWF';
import TRA_CUSTOMF from './../Scripts/Training/MultiTrainingPage/TRA_CUSTOM/TRA_CUSTOMF';
import SUG_BASICF from '../Scripts/Suggestions/SuggestionList/SUG_BASIC/SUG_BASICF';
import RIN_BASICF from '../Scripts/RiskNearMiss/RIN_BASIC/RIN_BASICF';
import SUG_DAIF from '../Scripts/Suggestions/SuggestionList/SUG_DAI/SUG_DAIF';
import { RIN_DAIF } from '../Scripts/RiskNearMiss/RIN_DAI';

/**
 * 동적 라우팅 설정 — DynamicRouteWrapper + menuInfo.proId
 */
export const routeConfig = {
  MultiTrainingPage: {
    default: TRA_CUSTOMF,
    TRA_NEW: TRA_NEWF,
  },

  SuggestionList: {
    default: SUG_BASICF,
    SUG_DAI: SUG_DAIF,
  },

  RiskNearMiss: {
    default: RIN_BASICF,
    RIN_DAI: RIN_DAIF,
  },
};

function isProIdComponentMap(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false;
  return typeof obj.default === 'function';
}

export function getComponentMapForMenu(menuId, path) {
  const menuConfig = routeConfig[menuId];
  if (!menuConfig) {
    console.warn(`라우트 설정을 찾을 수 없습니다: ${menuId}`);
    return null;
  }

  if (path != null && path !== '') {
    const pathConfig = menuConfig[path];
    if (!pathConfig) {
      console.warn(`경로 설정을 찾을 수 없습니다: ${menuId}/${path}`);
      return null;
    }
    return pathConfig;
  }

  if (isProIdComponentMap(menuConfig)) {
    return menuConfig;
  }

  const pathKeys = Object.keys(menuConfig);
  const orderedPaths = pathKeys.includes('list')
    ? ['list', ...pathKeys.filter((k) => k !== 'list')]
    : [...pathKeys];

  for (const pk of orderedPaths) {
    const candidate = menuConfig[pk];
    if (isProIdComponentMap(candidate)) {
      return candidate;
    }
  }

  console.warn(
    `menuId "${menuId}": path 없이 쓸 componentMap을 찾지 못했습니다.`
  );
  return null;
}

export function getComponent(menuId, path) {
  return getComponentMapForMenu(menuId, path);
}
